import React from 'react';
import styled from 'styled-components';

const ControlsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const ControlButton = styled.button`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: opacity 0.3s;
  
  &:hover {
    opacity: 0.8;
  }
  
  &.close { background: #ff5f57; }
  &.minimize { background: #ffbd2e; }
  &.maximize { background: #28ca42; }
`;

interface WindowControlsProps {
  onClose: () => void;
  onMinimize?: () => void;
  onMaximize?: () => void;
}

const WindowControls: React.FC<WindowControlsProps> = ({ 
  onClose, 
  onMinimize, 
  onMaximize 
}) => {
  const handleMinimize = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onMinimize) {
      onMinimize();
    }
  };

  const handleMaximize = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onMaximize) {
      onMaximize();
    }
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <ControlsContainer>
      <ControlButton className="close" onClick={handleClose} />
      <ControlButton className="minimize" onClick={handleMinimize} />
      <ControlButton className="maximize" onClick={handleMaximize} />
    </ControlsContainer>
  );
};

export default WindowControls;
